import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  grid: {
    justifyContent: 'space-between',
    background: 'linear-gradient(rgba(150, 202, 255, 0.18), rgba(150, 242, 255, 0.18))',
    backdropFilter: 'blur(10px)',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    width: 'calc(100% + 5px)',
    marginLeft: -2
  },
  claimInfoGroup: {
    marginTop: theme.spacing(4),
    border: 0,
    position: 'sticky',
    top: 0,
    zIndex: 3,
  },
  paddingBox: {
    height: theme.spacing(4),
    backgroundColor: theme.palette.background.paper,
    marginLeft: -2,
    width: 'calc(100% + 5px)'
  }
}));

function ClaimReviewOverview({ claim }) {
  const { t } = useTranslation();
  const classes = useStyles();

  // Defensive check for claim object
  if (!claim || !claim.dateOfLoss || !claim.causeOfLoss) {
    return null;
  }

  return (
    <fieldset className={classes.claimInfoGroup}>
      <Grid
        container
        spacing={2}
        className={classes.grid}
        justifyContent="space-between"
        direction='row'
      >
        <Grid item xs={6}>
          <Typography variant="h4" color="textPrimary">
            {claim.dateOfLoss}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t('claimDate')}
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right' }}>

          <Typography variant="h4" color="textPrimary">
            {claim.otherCauseOfLoss
              ? `${claim.causeOfLoss} - ${claim.otherCauseOfLoss}`
              : claim.causeOfLoss}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t('claimReason')}
          </Typography>
        </Grid>
      </Grid>
      <Box className={classes.paddingBox} />
    </fieldset>
  )
}

ClaimReviewOverview.propTypes = {
  claim: PropTypes.shape({
    product: PropTypes.string.isRequired,
    dateOfLoss: PropTypes.string.isRequired,
    causeOfLoss: PropTypes.string.isRequired,
    otherCauseOfLoss: PropTypes.string
  })
}

export default ClaimReviewOverview
